module.exports = __webpack_public_path__ + "img/scene-entry-banner-2.1089fa3d.png";